import type { ChangeEventHandler, ReactNode } from 'react';
import styles from './InputField.scss';

interface InputFieldProps {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement, HTMLInputElement>;
  placeholder: string;
  error: ReactNode;
  errorClassName?: string;
  label?: string;
}

const InputField = ({ value, onChange, label, placeholder, error, errorClassName }: InputFieldProps) => (
  <div className={styles.field}>
    {label ? <label>{label}</label> : null}

    <div className={styles.wrapper}>
      <input type="text" placeholder={placeholder} value={value} onChange={onChange} />
    </div>

    <div className={`${styles.error} ${errorClassName}`}>{error}</div>
  </div>
);

export default InputField;
